import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ViewUI from 'view-design';
// import style
import 'view-design/dist/styles/iview.css'
import '@/assets/common.css'    // 使用 CSS
import request from '@/utils/requestExt'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import GeminiScrollbar from 'vue-gemini-scrollbar'
Vue.use(GeminiScrollbar)

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

Vue.config.productionTip = false
Vue.use(ViewUI)

import {Timeline, TimelineItem} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Timeline)
Vue.use(TimelineItem)

// Vant
// import Vant from 'vant'
// import 'vant/lib/index.css'
// Vue.use(Vant)
// import { Lazyload } from 'vant'
// Vue.use(Lazyload)



// 全局路由守卫
router.beforeResolve((to, from, next) => {
  /* must call `next` */
  const { token, current } = store.state
  // 访问登录页面
  if (to.path === '/login' || to.path === '/register' || to.path === '/bind') {
    if (token && current) {
      next('/')
    } else {
      next()
    }
    return
  }
  // 访问非登录页
  if (!token) {
    return next('/login')
  }
  if (current) {
    return next()
  }
  request.get('/api/user/current')
  .then((data: any) => {
    const newData = data
    store.commit('setCurrent', newData)
    next()
  }).catch(() => {
  next('login')
})

})



new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
